import { motion } from 'framer-motion';
import { useParams } from 'react-router';
import { UpsertPriceTableForm } from '@/components/forms/commercial/price-table';

export function PriceTableEditPage() {
  const { id } = useParams<{ id: string }>();

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <UpsertPriceTableForm priceTableId={id} editMode />
    </motion.div>
  );
}
